import { render, staticRenderFns } from "./CreateFabric.vue?vue&type=template&id=0cf94afc&scoped=true"
import script from "./CreateFabric.vue?vue&type=script&lang=js"
export * from "./CreateFabric.vue?vue&type=script&lang=js"
import style0 from "./CreateFabric.vue?vue&type=style&index=0&id=0cf94afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf94afc",
  null
  
)

export default component.exports